import ko from '@tko/build.knockout';
import templateMarkup from 'raw-loader!./searchgrid2-widget.html';
    

    function SearchGrid2Widget(params) {
        var self = this;
    
        this.observableOptions = params.observableOptions;
        this.observableData = params.observableData;
        self.panelTemplate = params.panelTemplate;
        self.widgetSignals = params.widgetSignals;

        self.subscriptions = [];

        self.getObsParams = function(optschanged) {
            if (!params.observableParamsList) {
                return null;
            }

            var obsparams = params.observableParamsList[0]();

            if (params.viewLevelOptions && !$.isEmptyObject(params.viewLevelOptions())) {
                obsparams.queryId = self.panelTemplate.panelType;

                var paramsTemp = params.viewLevelOptions();

                paramsTemp.pageNum = (optschanged === true) ? params.observableOptions().pageNum : 1;
                paramsTemp.pageSize = params.observableOptions().pageSize;
                paramsTemp.sortIndex = params.observableOptions().sortIndex || 0;

                if (paramsTemp.sortIndex > (params.observableOptions().display.length - 1)) {
                    paramsTemp.sortIndex = 0;
                }

                paramsTemp.sortColumn = params.observableOptions().display[paramsTemp.sortIndex];
                if (paramsTemp.sortColumn && (params.observableOptions().sortAsc == false)) {
                    paramsTemp.sortColumn = paramsTemp.sortColumn + " DESC";
                }
                else {
                    paramsTemp.sortColumn = paramsTemp.sortColumn + " ASC";
                }
                obsparams.paramsJson = ko.toJSON(paramsTemp);
                return obsparams;
            }
            return null;
        };

        self.setObsParams = function (optschanged) {
            var obsparams = self.getObsParams(optschanged);
            if (!obsparams) {
                return;
            }

            if (self.widgetSignals) {
                self.widgetSignals().dataRequested.dispatch();
            }
            params.observableParamsList[0](obsparams);
        };

        self.subscriptions.push(params.viewLevelOptions.subscribe(self.setObsParams));

        self.RefreshData();

        self.subscriptions.push(self.observableData.subscribe(function () {
            self.DataUpdated();
        }));
        self.subscriptions.push(self.observableOptions.subscribe(function () { self.setObsParams(true); }));
    }

    SearchGrid2Widget.prototype.RefreshData = function () {
        var self = this;
        var data = self.observableData();

        if (!$.isEmptyObject(data)) {
            if (data.loadFromCacheCallback) {

                var params = self.getObsParams(false);
                if (!params) {
                    return;
                }
                if (!data.loadFromCacheCallback(params, data.context)) {
                    self.setObsParams(false);
                }
            }
        }
    };

    SearchGrid2Widget.prototype.DataUpdated = function () {
        var self = this;
        self.RefreshData();
    };

    // This runs when the component is torn down. Put here any logic necessary to clean up,
    // for example cancelling setTimeouts or disposing Knockout subscriptions/computeds.
    SearchGrid2Widget.prototype.dispose = function () {
        var self = this;
        self.subscriptions.forEach(function (sub) {
            sub.dispose();
        });
    };

    export default { viewModel: SearchGrid2Widget, template: templateMarkup };

